// sekcie_v2 (20. 10. 2026, ústava 61.10 + 92): telo detailu sivé, časti = biele karty; poradie blokov 92.3 nezmenené
// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 1 miest
// FaktDetail / FaDetailPane — Task #10 MVP
// Read-only detail vystavenej faktúry s tabmi: Info / Položky / Audit
// MVP: žiadny edit, žiadne pridanie úhrady (Matrix mirror MKsoft)

import React, { useState, useEffect, useMemo } from 'react'
import { useDirtyFlag } from '../hooks/useDirtyState.js'
import { strazKlik } from '../hooks/unsavedGuard.js'   // BLOCKY_MOCKUP_V4 č. 25: prepnutie tabu (Audit) sa spýta na rozpísané zaradenie   // straz_v1 (28. 9. 2026): rozpísané zaradenie drží stráž odchodu (ústava 53.1)
import { qrUhrada } from '../utils/qrPlatba.js'   // qr_lokalne_v1
import { fetchAuth, fetchAuthJSON } from '../auth/fetchAuth.js'
import { useToast } from '../components/Toast.jsx'
import RowMenu from '../components/RowMenu.jsx'
import { Btn, BtnNav, BtnGhost, BtnAdd } from '../components/Btn.jsx'
import { COLORS, TYPO, SPACE, RADIUS, SK, todayLocal } from '../theme.js'
import { Tabs, SearchableSelect, Sekcia } from '../components/Ui.jsx'   // sekcie_v2
import HelpHint from '../components/HelpHint.jsx'
import DelenieDokladu from '../components/DelenieDokladu.jsx'   // p26 (16. 9. 2026): delenie dokladu na časti
import { polozkySDph } from '../utils/dokladPolozky.js'   // p37 (17. 9. 2026): položky bez DPH / s DPH podľa dokladu
import { useAuth } from '../auth/AuthContext.jsx'
import { smieSpracovatBlocky, jeBlocekDoklad, ZARADI_BACK_OFFICE } from '../utils/blocky.js'   // BLOCKY_SPRACUJE_V1 (ústava 135.2)

export const REZIA_CATS_FD = ['Mzdy a odmeny','PHM (pohonné hmoty)','Poistenie','Prenájom priestorov','Opravy áut / servis','Bankové poplatky','Telefón / Internet','Účtovníctvo / Právne služby','IT a technika','Kancelárske potreby','Reštaurácie / Stravovanie','Nákup náradia / zariadenia','Oprava náradia / servis','Prenájom náradia','Notár / overenie / poplatky','Iné réžijné náklady']
export const ZAKAZKA_CATS_FD = ['Stavebný materiál','Zriadenie staveniska','PHM (pohonné hmoty — zákazka)','Nákup náradia / zariadenia','Oprava náradia / servis','Prenájom náradia','Subdodávka práce','Doprava na zákazku','Prenájom strojov','Iný zákazkový výdavok']

// p43 (Mirko 17. 9. 2026: „ak je to servis áut, opravy — možnosť priradiť, ku ktorému autu tá FA patrí, dôležité“)
export const jeAutoKategoria = (k) => /oprav|servis|phm|pohonn|pneu|stk|emisn|diaľnič|dialnic|vozid|auto/i.test(String(k || ''))
const autoPopis = (v) => [v.plate, [v.brand, v.model].filter(Boolean).join(' '), v.name].filter(Boolean).join(' · ') || ('auto ' + v.id)

// Stavy došlej FA — rýchla zmena bez vstupu do Upraviť (Mirko 2026-05-21)
// p43 (Nápady od office, Mirko 17. 9. 2026: „pri evidencii úhrady dať možnosť dátum úhrady a spôsob“)
const SPOSOBY_UHRADY = ['Bankový prevod', 'Hotovosť', 'Karta', 'Zápočet', 'Spoločná banková úhrada', 'Inkaso', 'Iné']

const STATUS_OPTS = [
  { key: 'unpaid',   label: 'Neuhradená',    color: COLORS.remove, icon: '' },
  { key: 'paid',     label: 'Uhradená',      color: COLORS.add,    icon: '✓' },
  { key: 'disputed', label: 'Sporná',        color: '#7c3aed',     icon: '' }
]

// StatusChanger — klikateľná zmena stavu FA priamo v detaile (ústava 53.4 Undo)
function StatusChanger({ fa, onReload, compact }) {
  const toast = useToast()
  const [busy, setBusy] = useState(false)
  const [askDate, setAskDate] = useState(false)
  const [payDate, setPayDate] = useState(todayLocal())
  const [paySpos, setPaySpos] = useState(fa.payment_method || 'Bankový prevod')   // p43: spôsob úhrady pri evidencii

  // aktuálny stav — DB status, fallback odvodenie
  const cur = fa.status || (fa.amount_paid >= fa.amount_total && fa.amount_total > 0 ? 'paid' : 'unpaid')
  const curCfg = STATUS_OPTS.find(s => s.key === cur) || { label: cur, color: COLORS.muted, icon: '' }

  async function changeStatus(newStatus, date, sposob) {
    setBusy(true)
    const prev = cur
    try {
      const r = await fetchAuth(`/api/incoming-invoices/${fa.realId}/status`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: newStatus, payment_date: date || '', payment_method: sposob || '' })
      })
      if (!r.ok) {
        const j = await r.json().catch(() => ({}))
        toast.error(`Zmena stavu zlyhala: ${j.error || 'HTTP ' + r.status}`)
        setBusy(false); return
      }
      const label = STATUS_OPTS.find(s => s.key === newStatus)?.label || newStatus
      // Undo toast 10s (ústava 53.4)
      toast.undo(`Stav zmenený na „${label}"`, async () => {
        await fetchAuth(`/api/incoming-invoices/${fa.realId}/status`, {
          method: 'PATCH', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ status: prev, payment_date: prev === 'paid' ? (fa.date_paid || '') : '', payment_method: prev === 'paid' ? (fa.payment_method || '') : '' })
        }).catch(() => {})
        onReload && onReload()
      })
      onReload && onReload()
    } catch (e) {
      toast.error(`Chyba: ${e.message}`)
    } finally {
      setBusy(false); setAskDate(false)
    }
  }

  function pick(key) {
    if (key === cur) return
    if (key === 'paid') { setAskDate(true); return }   // Uhradená → opýta dátum
    changeStatus(key)
  }

  // COMPACT — tenký subbar (ústava 92.1): „Stav úhrady → zmeniť:" + pills iných stavov, inline
  if (compact) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap' }}>
        <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Stav úhrady → zmeniť:</span>
        {STATUS_OPTS.filter(s => s.key !== cur).map(s => (
          <button key={s.key} type="button" disabled={busy} onClick={() => pick(s.key)}
            style={{ padding: '2px 10px', fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, cursor: busy ? 'default' : 'pointer', color: s.color, background: 'transparent', border: `1px solid ${s.color}`, borderRadius: RADIUS.full, fontFamily: 'inherit' }}>
            {s.icon} {s.label}
          </button>
        ))}
        {askDate && (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <input type="date" value={payDate} onChange={e => setPayDate(e.target.value)}
              style={{ padding: '3px 6px', fontSize: TYPO.sizes.xs, fontFamily: 'inherit', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm }} />
            <select value={paySpos} onChange={e => setPaySpos(e.target.value)} aria-label="Spôsob úhrady"
              style={{ padding: '3px 6px', fontSize: TYPO.sizes.xs, fontFamily: 'inherit', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, background: COLORS.bg, color: COLORS.text }}>
              {SPOSOBY_UHRADY.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
            <BtnAdd size="sm" onClick={() => changeStatus('paid', payDate, paySpos)} disabled={busy}>✓ Potvrdiť</BtnAdd>
            <BtnGhost size="sm" onClick={() => setAskDate(false)}>✕</BtnGhost>
          </span>
        )}
      </span>
    )
  }

  return (
    <div style={{
      background: COLORS.bg, border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.md, padding: SPACE.sm, marginBottom: SPACE.md
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap' }}>
        <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          Stav úhrady:
        </span>
        <span style={{
          padding: '2px 10px', fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.bold,
          color: curCfg.color, border: `1px solid ${curCfg.color}`, borderRadius: RADIUS.full
        }}>{curCfg.icon} {curCfg.label}</span>
        <span style={{ flex: 1 }} />
        <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>zmeniť →</span>
        {STATUS_OPTS.map(s => (
          <button key={s.key} type="button" disabled={busy || s.key === cur}
            onClick={() => pick(s.key)}
            style={{
              padding: '3px 10px', fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
              cursor: (busy || s.key === cur) ? 'default' : 'pointer',
              color: s.key === cur ? COLORS.disabled : s.color,
              background: 'transparent',
              border: `1px solid ${s.key === cur ? COLORS.line : s.color}`,
              borderRadius: RADIUS.full, opacity: s.key === cur ? 0.4 : 1,
              fontFamily: 'inherit'
            }}>
            {s.icon} {s.label}
          </button>
        ))}
      </div>
      {askDate && (
        <div style={{
          marginTop: SPACE.sm, padding: SPACE.sm, background: COLORS.addBg,
          border: `1px solid ${COLORS.add}`, borderRadius: RADIUS.sm,
          display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap'
        }}>
          <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.text }}>Dátum úhrady:</span>
          <input type="date" value={payDate} onChange={e => setPayDate(e.target.value)}
            style={{ padding: '4px 8px', fontSize: TYPO.sizes.sm, fontFamily: 'inherit', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm }} />
          <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.text }}>Spôsob:</span>
          <select value={paySpos} onChange={e => setPaySpos(e.target.value)} aria-label="Spôsob úhrady"
            style={{ padding: '4px 8px', fontSize: TYPO.sizes.sm, fontFamily: 'inherit', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, background: COLORS.bg, color: COLORS.text }}>
            {SPOSOBY_UHRADY.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <BtnAdd size="sm" onClick={() => changeStatus('paid', payDate, paySpos)} disabled={busy}>✓ Potvrdiť úhradu</BtnAdd>
          <BtnGhost size="sm" onClick={() => setAskDate(false)}>Zrušiť</BtnGhost>
        </div>
      )}
    </div>
  )
}

// Ústava 92: Položky NIE sú samostatný tab — sú inline v Info po Zaradenie
const TABS = [
  { key: 'info',     label: 'Info',      active: true },
  { key: 'audit',    label: 'Audit',     active: true }
]

const TYPE_LABELS = {
  FVSP: { label: 'FVSP — Stavebné práce', color: '#15803d' },
  FVO:  { label: 'FVO — Obchod / predajňa', color: '#0369a1' },
  FVE:  { label: 'FVE — Eshop', color: '#7c3aed' },
  ZA:   { label: 'ZA — Záloha', color: '#b45309' },
  DN:   { label: 'DN — Dobropis', color: '#dc2626' },
  manual: { label: 'Vystavené ručne v Matrix', color: '#d97706' }
}

// chip štýl s pastelovým pozadím (per typ)
function chipS(color) {
  return {
    display: 'inline-flex', alignItems: 'center', gap: 4,
    padding: '4px 10px',
    fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
    color: color, background: `${color}15`,
    border: `1px solid ${color}`, borderRadius: RADIUS.full,
  }
}

export function FaDetailPane({ fa, onReload, onEdit, menuActions, celaStrana, zaradZnova }) {
  const [tab, setTab] = useState('info')
  const [items, setItems] = useState([])
  const [itemsLoading, setItemsLoading] = useState(false)
  const toast = useToast()

  // Polozky — fetch vzdy (zobrazujú sa inline v Info po Zaradenie, ústava 92.3)
  useEffect(() => {
    let alive = true   // BLOCKY_MOCKUP_V4 č. 27: pri rýchlom prepínaní dokladov sa položky staršieho dokladu neprepíšu cez nový
    setItems([]); setItemsLoading(true)
    // Správne endpointy (Mirko 2026-06-09 „Vystavené FA netiahne položky"):
    //  mksoft (vystavené FVSP, tab. invoices)  → /api/imports/invoices/:id/items  → { items }
    //  matrix (ručné outgoing, outgoing_inv.)  → /api/imports/outgoing/:id/items   → { items }
    //  incoming (došlé / bločky)               → /api/incoming-invoices/:id/items  → [ ]
    const url = fa.source === 'incoming'
      ? `/api/incoming-invoices/${fa.realId}/items`
      : fa.source === 'mksoft'
      ? `/api/imports/invoices/${fa.realId}/items`
      : `/api/imports/outgoing/${fa.realId}/items`
    fetchAuth(url).then(r => r.ok ? r.json() : []).then(d => {
      if (!alive) return
      const arr = Array.isArray(d) ? d : (d && Array.isArray(d.items) ? d.items : [])
      setItems(arr)
    })
      .catch(() => { if (alive) setItems([]) })
      .finally(() => { if (alive) setItemsLoading(false) })
    return () => { alive = false }
  }, [fa.realId, fa.source])

  const typeCfg = TYPE_LABELS[fa.typ] || { label: fa.typ || 'Neznámy typ', color: COLORS.muted }
  const remain = fa.amount_total - fa.amount_paid

  // Ústava 92.1 — tenká hlavička: číslo·partner + badge + akcie; subbar: stav pills + taby
  const isIncoming = fa.source === 'incoming'
  const isBlocek = isIncoming && (fa.docType === 'blocok' || fa.typ === 'BLOCEK')
  const isIncomingFA = isIncoming && !isBlocek
  const titleName = isIncoming ? (fa.supplier_name || '') : (fa.customer_name || '')
  const payCur = fa.status || (fa.amount_paid >= fa.amount_total && fa.amount_total > 0 ? 'paid' : 'unpaid')
  const payCfg = STATUS_OPTS.find(s => s.key === payCur) || { label: payCur, color: COLORS.muted, icon: '' }
  const badgeS = (color) => ({ padding: '2px 9px', fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color, background: '#fff', border: `1px solid ${color}`, borderRadius: RADIUS.full, whiteSpace: 'nowrap' })

  return (
    <div style={{
      background: COLORS.bg,
      border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.lg,
      padding: SPACE.md,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      {/* TENKÁ ORANŽOVÁ LIŠTA (ústava 92.1) — KOMPAKTNÉ */}
      <div style={{ height: 3, background: COLORS.brand, margin: `-${SPACE.md}px -${SPACE.md}px ${SPACE.sm}px` }} />

      {/* TENKÁ HLAVIČKA: číslo·partner + badge + akcie */}
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap', marginBottom: SPACE.sm }}>
        <h2 style={{ margin: 0, fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.extra, lineHeight: 1.2 }}>
          <span style={{ color: COLORS.nav, fontFamily: TYPO.mono }}>{fa.cislo || '(bez čísla)'}</span>
          {titleName && <span style={{ color: COLORS.text }}> · {titleName}</span>}
        </h2>
        {isIncomingFA && <span style={badgeS(payCfg.color)}>{payCfg.icon} {payCfg.label}</span>}
        {isBlocek && <span style={badgeS(COLORS.add)}>✓ Uhradené</span>}
        {!isIncoming && <span style={badgeS(typeCfg.color)}>{typeCfg.label}</span>}
        {isBlocek && fa.cost_center === 'rezia' && <span style={chipS('#7c3aed')}>Réžia</span>}
        {isBlocek && fa.cost_center === 'zakazka' && <span style={chipS('#0ea5e9')}>Zákazka {fa.project_id ? `(${fa.project_id})` : ''}</span>}
        <span style={{ flex: 1 }} />
        <BtnGhost size="sm" onClick={() => toast.info('PDF — pripravujeme')}>PDF</BtnGhost>
        <BtnGhost size="sm" onClick={() => toast.info('Tlač — pripravujeme')}>Tlač</BtnGhost>
        {onEdit && <BtnNav size="sm" onClick={() => onEdit(fa)} title="Upraviť doklad">Upraviť</BtnNav>}
        {Array.isArray(menuActions) && menuActions.length > 0 && <RowMenu actions={menuActions} />}
      </div>

      {/* TENKÝ SUBBAR: stav úhrady → zmeniť (pills) · taby vpravo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.md, flexWrap: 'wrap', paddingBottom: 6, borderBottom: `1px solid ${COLORS.lineSoft}`, marginBottom: SPACE.md }}>
        {/* p43 (Mirko 17. 9. 2026): „typ úhrady by som zadával až po zaradení FA do Došlé FA“ — dovtedy je doklad Na určenie */}
        {isIncomingFA && (fa.kind_confirmed
          ? <StatusChanger fa={fa} onReload={onReload} compact />
          : <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Úhradu označíš <b>po zaradení</b> — zaradený doklad je v Došlých FA ako nezaplatený (saldo).</span>)}
        <span style={{ flex: 1 }} />
        {TABS.map(t => (
          <span key={t.key} onClick={strazKlik(() => setTab(t.key))}
            style={{ cursor: 'pointer', fontSize: TYPO.sizes.sm, color: tab === t.key ? COLORS.nav : COLORS.muted, fontWeight: tab === t.key ? TYPO.weights.bold : 400, borderBottom: tab === t.key ? `2px solid ${COLORS.nav}` : '2px solid transparent', paddingBottom: 4 }}>
            {t.label}
          </span>
        ))}
      </div>

      {/* ČAKÁ NA URČENIE — Matrix návrh + 1-klik potvrdenie (ústava 12.0 bod 3) */}
      {fa.source === 'incoming' && !fa.kind_confirmed && (
        <KindConfirmBanner fa={fa} onReload={onReload} onEdit={onEdit} />
      )}

      {/* TAB CONTENT — sekcie_v2 (ústava 61.10): sivé telo, každá časť je samostatná biela karta */}
      <div style={{ flex: 1, overflow: 'auto', background: COLORS.page,
        borderRadius: RADIUS.lg, padding: SPACE.md, margin: `0 -${SPACE.sm}px -${SPACE.sm}px` }}>
        {/* FAKTDETAIL_KEY_V1 (Mirko 24. 10.: Uložiť po prepnutí dokladu nič neuložilo) — zaradenie sa pri každom doklade načíta nanovo, nikdy nezostane z predošlého */}
        {tab === 'info' && <InfoTab key={fa.realId} fa={fa} remain={remain} onReload={onReload} items={items} itemsLoading={itemsLoading} celaStrana={celaStrana} zaradZnova={zaradZnova} />}
        {tab === 'audit' && <AuditTab fa={fa} />}
      </div>
    </div>
  )
}

// buildEpcQr — EPC QR (SEPA Credit Transfer / Pay by Square) — ústava 14.4
// Port zo starého IncomingInvoicesView.jsx. Funguje len pre SK IBAN.
function buildEpcQr(fa) {
  // qr_lokalne_v1: jedno miesto pre QR na úhradu (utils/qrPlatba.js), kreslí sa lokálne — nič neodchádza von
  const ref = (fa.vs || fa.cislo || '')
  return qrUhrada({ iban: fa.supplier_iban, suma: fa.amount_total, prijemca: fa.supplier_name, vs: ref, poznamka: 'Platba ' + ref })
}

// QrPayment — QR kód na úhradu (EPC/GiroCode SEPA — funguje SK bankám, port zo starého Matrixu).
// Mirko 2026-06-09: bysquare nefungoval jeho banke; EPC/BCD v starom Matrixe fungoval → vrátené.
function QrPayment({ fa }) {
  const url = buildEpcQr(fa)
  if (!url) {
    return (
      <div style={{ padding: SPACE.sm, background: COLORS.bgSoft, borderRadius: RADIUS.md, fontSize: 11, color: COLORS.muted, textAlign: 'center' }}>
        💳 QR platba nedostupná — chýba/neplatný SK IBAN. Doplň cez „Upraviť".
      </div>
    )
  }
  const small = url   // qr_lokalne_v1: vektor, veľkosť dáva štýl obrázka
  return (
    <div style={{
      background: COLORS.bg, border: `1px solid ${COLORS.add}`, borderLeft: `3px solid ${COLORS.add}`,
      borderRadius: RADIUS.md, padding: SPACE.sm, textAlign: 'center'
    }}>
      <div style={{ fontSize: 10, fontWeight: TYPO.weights.bold, color: COLORS.add, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 }}>
        💳 QR na úhradu
      </div>
      <img src={small} alt="QR platba" style={{ width: 200, height: 200, background: '#fff', padding: 4, borderRadius: RADIUS.sm }} />
      <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 6, lineHeight: 1.35, wordBreak: 'break-all' }}>
        <span style={{ fontFamily: TYPO.mono, color: COLORS.text }}>{fa.supplier_iban}</span>
        {fa.vs && <><br/>VS <span style={{ fontFamily: TYPO.mono, color: COLORS.nav, fontWeight: TYPO.weights.semibold }}>{fa.vs}</span></>}
        {' · '}<span style={{ fontFamily: TYPO.mono, color: COLORS.total, fontWeight: TYPO.weights.semibold }}>{SK.eur(fa.amount_total)}</span>
      </div>
      <div style={{ fontSize: 9, color: COLORS.disabled, marginTop: 3 }}>SEPA / EPC platba</div>
    </div>
  )
}

// Thumbnail — miniatúra prílohy FA (PDF/foto) pod QR (ústava 92.2)
function Thumbnail({ fa, velky }) {
  const url = fa.attachment_url || (fa.attachment_path ? '/uploads/' + fa.attachment_path : (fa.doc_file ? '/uploads/' + fa.doc_file : ''))
  const isImg = url && /\.(jpe?g|png|webp|gif)$/i.test(url)
  const name = (fa.attachment_path || fa.doc_file) ? String(fa.attachment_path || fa.doc_file).split('/').pop()
    : (fa.cislo ? 'Faktúra_' + fa.cislo + '.pdf' : 'Príloha')
  return (
    <div style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.sm, textAlign: 'center', marginTop: SPACE.sm }}>
      {url ? (
        <a href={url} target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
          {isImg
            ? <img src={url} alt="Príloha FA" style={{ width: '100%', maxHeight: velky ? 'calc(100vh - 230px)' : 440, objectFit: 'contain', borderRadius: RADIUS.sm, border: `1px solid ${COLORS.line}` }} />
            : <embed src={url + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH'} type="application/pdf" style={{ width: '100%', height: velky ? 'calc(100vh - 230px)' : 440, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, background: '#fff', pointerEvents: 'none' }} />}
          <div style={{ fontSize: 10, color: COLORS.muted, marginTop: 6, wordBreak: 'break-all' }}>{name}</div>
        </a>
      ) : (
        <div style={{ fontSize: 11, color: COLORS.muted, padding: SPACE.sm }}>
          Bez prílohy
          <div style={{ fontSize: 9, marginTop: 2 }}>PDF/foto doplníš cez „Upraviť"</div>
        </div>
      )}
    </div>
  )
}

// KindConfirmBanner — "Čaká na určenie": Matrix návrh + 1-klik potvrdenie (ústava 12.0 bod 3)
function KindConfirmBanner({ fa, onReload, onEdit }) {
  const toast = useToast()
  const { user } = useAuth()
  const lenBackOffice = jeBlocekDoklad(fa) && !smieSpracovatBlocky(user)   // BLOCKY_SPRACUJE_V1: bloček potvrdí back office (135.2)
  const [busy, setBusy] = useState(false)
  const hasKind = !!fa.invoice_kind
  const kindLabel = fa.invoice_kind === 'nakladova' ? 'Nákladová' : fa.invoice_kind === 'evidencna' ? 'Evidenčná' : null
  const centerLabel = fa.cost_center === 'rezia' ? 'Správna réžia' : fa.cost_center === 'zakazka' ? 'Na zákazku' : null

  async function confirmKind() {
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/incoming-invoices/${fa.realId}/confirm-kind`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: '{}'
      })
      if (!r.ok) {
        const j = await r.json().catch(() => ({}))
        toast.error(`Potvrdenie zlyhalo: ${j.error || 'HTTP ' + r.status}`)
        setBusy(false); return
      }
      toast.success('Zaradenie potvrdené')
      onReload && onReload()
    } catch (e) {
      toast.error(`Chyba: ${e.message}`)
    } finally { setBusy(false) }
  }

  return (
    <div style={{
      background: COLORS.totalBg, border: `1px solid ${COLORS.warn}`, borderLeft: `3px solid ${COLORS.warn}`,
      borderRadius: RADIUS.md, padding: SPACE.md, marginBottom: SPACE.md
    }}>
      <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.bold, color: COLORS.warn, marginBottom: SPACE.xs }}>
        Čaká na určenie typu výdavku
      </div>
      {hasKind ? (
        <>
          <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.text, marginBottom: SPACE.sm }}>
            <strong>Matrix navrhuje zaradenie:</strong>{' '}
            <span style={{ fontWeight: TYPO.weights.semibold }}>{kindLabel}</span>
            {centerLabel && <> · {centerLabel}</>}
            {fa.cost_category && <> · {fa.cost_category}</>}
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2 }}>
              {lenBackOffice ? 'Podľa histórie tohto dodávateľa.' : 'Podľa histórie tohto dodávateľa. Skontroluj — ak sedí, potvrď jedným klikom.'}
            </div>
          </div>
          {lenBackOffice ? (
            <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted }}>{ZARADI_BACK_OFFICE}</div>
          ) : (
          <div style={{ display: 'flex', gap: SPACE.sm }}>
            <BtnAdd size="sm" onClick={confirmKind} disabled={busy}>
              {busy ? 'Potvrdzujem…' : '✓ Potvrdiť toto zaradenie'}
            </BtnAdd>
            {onEdit && <BtnGhost size="sm" onClick={() => onEdit(fa)}>Zmeniť</BtnGhost>}
          </div>
          )}
        </>
      ) : (
        <>
          <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.text, marginBottom: SPACE.sm }}>
            Tento doklad ešte nemá určený typ (Evidenčná / Nákladová). {lenBackOffice ? ZARADI_BACK_OFFICE : 'Zaraď ho, aby sa správne počítal v nákladoch.'}
          </div>
          {onEdit && !lenBackOffice && <BtnNav size="sm" onClick={() => onEdit(fa)}>Zaradiť doklad</BtnNav>}
        </>
      )}
    </div>
  )
}

function InfoTab({ fa, remain, onReload, items, itemsLoading, celaStrana, zaradZnova }) {
  const isBlocek = fa.docType === 'blocok' || fa.typ === 'BLOCEK'  // blocek = vzdy uhradeny
  const isPaid = isBlocek || remain <= 0.01
  const isIncoming = fa.source === 'incoming'
  const toast = useToast()
  const { user } = useAuth()
  const lenBackOffice = isIncoming && isBlocek && !smieSpracovatBlocky(user)   // BLOCKY_SPRACUJE_V1: zaradenie bločku mení len back office (135.2)
  const [cc, setCc] = useState(fa.cost_center || 'rezia')
  const [kind, setKind] = useState(fa.invoice_kind || 'nakladova')
  const [cat, setCat] = useState(fa.cost_category || '')
  const [savingZ, setSavingZ] = useState(false)
  const [delit, setDelit] = useState(fa.invoice_kind === 'delena')   // p26: doklad rozdelený na časti (evidenčná / réžia / zákazka)
  // Mirko 15. 9. 2026: „ak je FA správne zaradená, Zaradenie (office) by sa malo automaticky skryť“ — jeden riadok a tlačidlo Zmeniť zaradenie
  const [zmenitZ, setZmenitZ] = useState(false)
  useEffect(() => { setZmenitZ(false); setDelit(fa.invoice_kind === 'delena') }, [fa.realId, fa.invoice_kind])
  const zaradena = isIncoming && !!fa.kind_confirmed && (fa.invoice_kind === 'evidencna' || fa.invoice_kind === 'delena' || (fa.invoice_kind === 'nakladova' && ((fa.cost_center === 'rezia' && !!fa.cost_category) || (fa.cost_center === 'zakazka' && !!fa.project_id && !!fa.cost_category))))
  const [projId, setProjId] = useState(fa.project_id || '')
  const [projects, setProjects] = useState([])
  const [linkedP, setLinkedP] = useState(null)
  // p43: servis/oprava/PHM → ku ktorému autu doklad patrí; návrh zaradenia z histórie dodávateľa
  const [vehId, setVehId] = useState(fa.vehicle_id ? String(fa.vehicle_id) : '')
  const [vehicles, setVehicles] = useState([])
  const [navrh, setNavrh] = useState(null)
  // straz_v1: zaradenie zmenené a neuložené → prepnutie dokladu, záložky alebo modulu sa spýta Uložiť / Zahodiť / Zrušiť
  const _z0 = { cc: fa.cost_center || 'rezia', kind: fa.invoice_kind || 'nakladova', cat: fa.cost_category || '', projId: fa.project_id || '', vehId: fa.vehicle_id ? String(fa.vehicle_id) : '', delit: fa.invoice_kind === 'delena' }
  const _zDirty = (cc !== _z0.cc || kind !== _z0.kind || cat !== _z0.cat || String(projId || '') !== _z0.projId || vehId !== _z0.vehId || delit !== _z0.delit)
  useDirtyFlag(_zDirty, { key: 'fd-zaradenie', save: () => saveZaradenie(), discard: () => { setCc(_z0.cc); setKind(_z0.kind); setCat(_z0.cat); setProjId(_z0.projId); setVehId(_z0.vehId); setDelit(_z0.delit); setZmenitZ(false) } })
  useEffect(() => { setVehId(fa.vehicle_id ? String(fa.vehicle_id) : '') }, [fa.realId, fa.vehicle_id])
  useEffect(() => { if (!isIncoming) return; fetchAuthJSON('/api/vehicles').then(v => setVehicles((Array.isArray(v) ? v : (v && v.rows) || []).filter(x => x && x.active !== 0))).catch(() => {}) }, [isIncoming])
  useEffect(() => { if (!isIncoming) return; fetchAuthJSON(`/api/incoming-invoices/${fa.realId}/navrh`).then(setNavrh).catch(() => setNavrh(null)) }, [fa.realId, isIncoming])
  useEffect(() => { if (zaradZnova) setZmenitZ(true) }, [zaradZnova])
  useEffect(() => { fetchAuthJSON('/api/projects').then(p => setProjects((Array.isArray(p) ? p : []).filter(x => !x.archived))).catch(() => {}) }, [])
  useEffect(() => { fetchAuthJSON(`/api/incoming-invoices/${fa.realId}/linked-person`).then(setLinkedP).catch(() => {}) }, [])
  const vztahLabel = v => v === 'self_szco' ? 'vlastná SZČO' : v === 'rodinny' ? 'rodinná SZČO' : v === 'manzelka' ? 'manželkina SZČO' : 'spriaznený partner'
  const catOpts = (cc === 'zakazka' ? ZAKAZKA_CATS_FD : REZIA_CATS_FD)
  const topKind = delit ? 'delit' : (kind === 'evidencna' ? 'evidencna' : cc)
  const setTop = (t) => { if (t === 'delit') { setDelit(true); return } setDelit(false); if (t === 'evidencna') { setKind('evidencna'); setCat('') } else { setKind('nakladova'); setCc(t); setCat('') } }
  const TOPS = [{ key: 'evidencna', label: 'Evidenčná', color: '#6366f1' }, { key: 'rezia', label: 'Réžia', color: '#7c3aed' }, { key: 'zakazka', label: 'Zákazka', color: '#0ea5e9' }, { key: 'delit', label: 'Deliť', color: '#0f766e' }].filter(t => t.key !== 'delit' || !isBlocek)   // p37: eKasa bločky sa nedelia (Mirko 17. 9. 2026)
  const saveZaradenie = async () => {
    setSavingZ(true)
    try {
      const r = await fetchAuth(`/api/incoming-invoices/${fa.realId}/confirm-kind`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ invoice_kind: kind, cost_center: kind === 'evidencna' ? '' : cc, cost_category: kind === 'evidencna' ? '' : cat, project_id: (kind !== 'evidencna' && cc === 'zakazka') ? projId : '', vehicle_id: (kind !== 'evidencna' && jeAutoKategoria(cat)) ? vehId : '' }) })
      if (!r.ok) { let m = 'HTTP ' + r.status; try { const j = await r.json(); if (j && j.error) m = j.error } catch (_) {} throw new Error(m) }
      toast.success('Zaradenie uložené'); setZmenitZ(false); onReload && onReload(); return true
    } catch (e) { toast.error('Chyba: ' + e.message); return false } finally { setSavingZ(false) }
  }

  // === ÚSTAVA 92 — záväzná šablóna detailu ===
  // Pravý stĺpec (float): QR hore + miniatúra pod ním. Ľavý obsah v BFC (žiadny pás pod QR).
  // p43 (Mirko 17. 9. 2026: „zobrazenie faktúry je malé, nevidím ho — kliknutím na faktúru zobraziť doklad so zaradením na celú stranu“):
  // na celú stranu je doklad veľký vľavo, údaje a zaradenie vpravo; v úzkom paneli ostáva pôvodné rozloženie.
  return (
    <div style={celaStrana
      ? { display: 'grid', gridTemplateColumns: 'minmax(360px, 1fr) minmax(420px, 1fr)', gap: SPACE.lg, alignItems: 'start' }
      : { overflow: 'hidden' }}>
      {celaStrana ? (
        <div style={{ position: 'sticky', top: 0, display: 'flex', flexDirection: 'column', gap: SPACE.sm, minWidth: 0 }}>
          <Thumbnail fa={fa} velky />
          {isIncoming && !isPaid && <div style={{ maxWidth: 280 }}><QrPayment fa={fa} /></div>}
        </div>
      ) : (
      <div style={{ float: 'right', width: 280, marginLeft: SPACE.md, marginBottom: SPACE.md, background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: SPACE.sm }}>   {/* sekcie_v2: náhľad dokladu je karta */}
        {isIncoming && !isPaid && <QrPayment fa={fa} />}
        <Thumbnail fa={fa} />
      </div>
      )}

      {/* ĽAVÝ OBSAH — jeden uzavretý stĺpec (BFC) — zastaví sa pri QR */}
      <div style={{ overflow: 'hidden' }}>
        {/* Polia v gridoch — KROS mriežka · sekcie_v2: jedna karta Doklad */}
        <Sekcia nazov={isBlocek ? 'Bloček' : isIncoming ? 'Doklad' : 'Faktúra'} style={{ marginBottom: 0 }}>
        {isIncoming ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr 1.2fr', gap: SPACE.sm }}>
              <Field label="Dodávateľ" value={fa.supplier_name} />
              <Field label="IČO dodávateľa" value={fa.supplier_ico} mono />
              <Field label="Zákazka" value={fa.project_id || 'čaká na priradenie'} />
            </div>
            {!isBlocek && (
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1.6fr', gap: SPACE.sm }}>
                <Field label="Spôsob úhrady" value={fa.payment_method || 'Bankový prevod'} />
                <Field label="Variabilný symbol" value={fa.vs} mono />
                <Field label="IBAN / Číslo účtu" value={fa.supplier_iban} mono />
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: SPACE.sm }}>
              <Field label="Dátum vystavenia" value={fa.date_issued} />
              {isBlocek
                ? <><Field label="Spôsob platby" value={fa.payment_method} /><Field label="Stav" value="✓ uhradené na pokladni" /></>
                : <><Field label="Dátum splatnosti" value={fa.date_due} /><Field label="Dátum dodania" value={fa.date_delivered} /><Field label="Dátum úhrady" value={fa.date_paid || (isPaid ? 'uhradené' : '— neuhradené —')} /></>}
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: SPACE.sm }}>
              <Field label="Zákazník" value={fa.customer_name} />
              <Field label="Zákazka" value={fa.project_id || '— bez zákazky —'} />
              <Field label="VS" value={fa.vs} mono />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: SPACE.sm }}>
              <Field label="Dátum vystavenia" value={fa.date_issued} />
              <Field label="Dátum splatnosti" value={fa.date_due} />
              <Field label="Dátum úhrady" value={fa.date_paid || (isPaid ? 'uhradené' : '— neuhradené —')} />
              <Field label="MKsoft č." value={fa.mksoft_cislo} mono />
            </div>
          </div>
        )}
        </Sekcia>

        {/* Sumy — kompaktný riadok · sekcie_v2: karta Úhrada */}
        <Sekcia nazov="Úhrada" style={{ marginBottom: 0, marginTop: SPACE.md }}>
        <div style={{ display: 'grid', gridTemplateColumns: isBlocek ? '1fr' : 'repeat(3, 1fr)', gap: SPACE.sm }}>
          <SumCard label="Suma celkom" value={SK.eur(fa.amount_total)} color={COLORS.nav} highlight />
          {!isBlocek && <SumCard label="Uhradené" value={SK.eur(fa.amount_paid)} color={COLORS.add} />}
          {!isBlocek && <SumCard label="Zostáva"  value={SK.eur(remain)} color={remain > 0 ? COLORS.remove : COLORS.muted} />}
        </div>
        </Sekcia>

        {/* Zaradenie (Office) — hneď pod dátumami/sumami (ústava 92.3); správne zaradená FA = jeden riadok (Mirko 15. 9. 2026) */}
        {isIncoming && zaradena && !zmenitZ && (
          <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: '10px 14px', marginTop: SPACE.md, display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap' }}>
            <span style={{ fontSize: TYPO.sizes.base, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{isBlocek ? 'Zaradenie (Štefánia)' : 'Zaradenie (Office)'}</span>
            <span style={{ fontSize: TYPO.sizes.sm, fontWeight: 700, color: COLORS.add }}>Zaradená</span>
            <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.text }}>{fa.invoice_kind === 'delena' ? 'Rozdelená na časti' : fa.invoice_kind === 'evidencna' ? 'Evidenčná' : fa.cost_center === 'rezia' ? 'Réžia' : 'Zákazka ' + ((projects.find(p => p.id === fa.project_id) || {}).name || fa.project_id || '')}{fa.invoice_kind !== 'evidencna' && fa.cost_category ? ' · ' + fa.cost_category : ''}{fa.vehicle_id ? ' · auto ' + ((vehicles.find(v => String(v.id) === String(fa.vehicle_id)) || {}).plate || fa.vehicle_id) : ''}</span>
            <span style={{ flex: 1 }} />
            {lenBackOffice
              ? <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{ZARADI_BACK_OFFICE}</span>
              : <BtnGhost size="sm" onClick={() => setZmenitZ(true)}>Zmeniť zaradenie</BtnGhost>}
          </div>
        )}
        {isIncoming && !zaradena && lenBackOffice && (
          <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: '10px 14px', marginTop: SPACE.md, display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap' }}>
            <span style={{ fontSize: TYPO.sizes.base, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Zaradenie</span>
            <span style={{ fontSize: TYPO.sizes.sm, fontWeight: 700, color: COLORS.warn }}>Čaká na Štefániu</span>
            <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{ZARADI_BACK_OFFICE}</span>
          </div>
        )}
        {isIncoming && !lenBackOffice && !(zaradena && !zmenitZ) && (
          <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: '12px 14px', marginTop: SPACE.md }}>
            <div style={{ fontSize: TYPO.sizes.base, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: SPACE.sm, display: 'flex', alignItems: 'center' }}>{isBlocek ? 'Zaradenie (Štefánia)' : 'Zaradenie (Office)'} <HelpHint text="ČO: kam patrí náklad z tejto došlej FA — réžia firmy alebo konkrétna zákazka + kategória nákladu. PREČO: podľa toho sa náklad počíta do réžie, alebo do nákladov a čerpania danej zákazky. KAM: réžia = náklad firmy; zákazka = náklad + čerpanie tej zákazky. (S účtovaním/predkontáciou to nesúvisí — to je samostatne.)" /></div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
              {navrh && navrh.navrh && navrh.uplny && (
                <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: RADIUS.md, padding: '7px 11px' }}>
                  <span style={{ fontSize: TYPO.sizes.xs, color: '#1e3a8a' }}>
                    Návrh podľa histórie dodávateľa: <b>{navrh.navrh.invoice_kind === 'evidencna' ? 'Evidenčná' : (navrh.navrh.cost_center === 'zakazka' ? 'Zákazka ' + ((projects.find(p => p.id === navrh.navrh.project_id) || {}).name || navrh.navrh.project_id || '') : 'Réžia') + (navrh.navrh.cost_category ? ' · ' + navrh.navrh.cost_category : '')}</b>
                    {' '}({navrh.pocet} z posledných {navrh.zo})
                  </span>
                  <BtnGhost size="sm" onClick={() => {
                    const n = navrh.navrh
                    setDelit(false)
                    if (n.invoice_kind === 'evidencna') { setKind('evidencna'); setCat('') }
                    else { setKind('nakladova'); setCc(n.cost_center || 'rezia'); setCat(n.cost_category || ''); setProjId(n.project_id || '') }
                    if (n.vehicle_id) setVehId(String(n.vehicle_id))
                  }}>Použiť návrh</BtnGhost>
                </div>
              )}
              <div style={{ display: 'flex', gap: SPACE.xs, flexWrap: 'wrap' }}>
                {TOPS.map(t => (
                  <button key={t.key} onClick={() => setTop(t.key)}
                    style={{ padding: '8px 18px', fontSize: TYPO.sizes.sm, fontWeight: 700, color: topKind === t.key ? '#fff' : t.color, background: topKind === t.key ? t.color : 'transparent', border: `2px solid ${t.color}`, borderRadius: RADIUS.md, cursor: 'pointer', fontFamily: 'inherit' }}>
                    {t.label}</button>
                ))}
              </div>
              {topKind !== 'evidencna' && topKind !== 'delit' && (
                <div>
                  <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Kategória nákladu</div>
                  <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginBottom: SPACE.xs }}>
                    {catOpts.map(k => (
                      <button key={k} onClick={() => setCat(k)}
                        style={{ padding: '4px 11px', fontSize: TYPO.sizes.xs, fontWeight: 600, color: cat === k ? '#fff' : COLORS.text, background: cat === k ? COLORS.nav : COLORS.bg, border: `1px solid ${cat === k ? COLORS.nav : COLORS.line}`, borderRadius: RADIUS.full, cursor: 'pointer', fontFamily: 'inherit' }}>
                        {k}</button>
                    ))}
                  </div>
                  <div style={{ maxWidth: 280 }}>
                    <SearchableSelect menuPortal value={cat} onChange={setCat} allowCreate options={catOpts.map(k => ({ value: k, label: k }))} placeholder="…alebo iná / vlastná kategória" />
                  </div>
                </div>
              )}
              {topKind !== 'evidencna' && topKind !== 'delit' && jeAutoKategoria(cat) && (
                <div>
                  <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Ku ktorému autu</div>
                  <div style={{ maxWidth: 360 }}>
                    <SearchableSelect menuPortal value={vehId} onChange={setVehId}
                      options={[{ value: '', label: '— bez auta —' }, ...vehicles.map(v => ({ value: String(v.id), label: autoPopis(v) }))]}
                      placeholder="Vyber auto…" />
                  </div>
                  <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3 }}>Servis, oprava, pneumatiky alebo PHM sa priradia k autu — náklady uvidíš pri vozidle.</div>
                </div>
              )}
              {topKind === 'evidencna' && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Evidenčná = ide na sklad (VSZAK/VSOST v MKsoft) — bez strediska/kategórie, nie je priamy náklad.</div>}
              {topKind === 'zakazka' && (
                <div>
                  <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>Ktorá zákazka <span style={{ color: COLORS.remove }}>*</span></div>
                  <div style={{ maxWidth: 360 }}>
                    <SearchableSelect menuPortal value={projId} onChange={setProjId}
                      options={projects.map(p => ({ value: p.id, label: `${p.name}${p.zakazka_code ? ' · ' + p.zakazka_code : ''}` }))}
                      placeholder="Vyber zákazku…" />
                  </div>
                  <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 3 }}>Náklad z tejto FA sa priradí do <b>Výdavkov</b> a čerpania tejto zákazky (vlákno).</div>
                </div>
              )}
              {topKind === 'zakazka' && linkedP && linkedP.linked && (
                <div style={{ fontSize: 12, background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: RADIUS.md, padding: '9px 12px', color: '#1e3a8a', lineHeight: 1.55 }}>
                  <b>Spriaznená osoba (ústava 11.6b):</b> dodávateľ <b>{linkedP.partner_name}</b> je {vztahLabel(linkedP.vztah)} zamestnanca <b>{linkedP.employee_name}</b>.<br />
                  Po uložení {projId ? <>vznikne <b>výdavok zákazky</b> a</> : ''} táto FA sa eviduje ako <b>odmena {linkedP.employee_name}</b> v jeho Finančnom prehľade (tok peňazí na osobu/rodinu — bez dvojzápočtu so mzdou).
                </div>
              )}
              {topKind === 'delit' && (
                <>
                  {!(items || []).length && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap' }}>
                      <NacitatPolozky fa={fa} onReload={onReload} maly />
                    </div>
                  )}
                  <DelenieDokladu invoiceId={fa.realId} projects={projects} reziaCats={REZIA_CATS_FD} zakazkaCats={ZAKAZKA_CATS_FD}
                    onSaved={() => { setZmenitZ(false); onReload && onReload() }} />
                </>
              )}
              {topKind !== 'delit' && fa.invoice_kind === 'delena' && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.remove }}>Doklad je rozdelený na časti. Ak ho chceš zaradiť celý, otvor Deliť a zruš delenie.</div>}
              {topKind !== 'delit' && <div><BtnAdd onClick={saveZaradenie} disabled={savingZ || fa.invoice_kind === 'delena' || (topKind !== 'evidencna' && !cat) || (topKind === 'zakazka' && !projId)}>{savingZ ? '…' : 'Uložiť zaradenie'}</BtnAdd></div>}
            </div>
          </div>
        )}

        {/* Položky INLINE — hneď po Zaradenie (ústava 92.3, NIE samostatný tab) · sekcie_v2: karta */}
        <div style={{ marginTop: SPACE.md, background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: '4px 14px 12px' }}>
          <PolozkyTab items={items || []} loading={itemsLoading} fa={fa} />
          {isIncoming && !itemsLoading && !(items || []).length && (
            <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap', marginTop: SPACE.xs }}>
              <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Doklad má položky na papieri, ale v Matrixe zatiaľ nie sú — načítaj ich z prílohy alebo doplň cez Upraviť.</span>
              <NacitatPolozky fa={fa} onReload={onReload} maly />
            </div>
          )}
        </div>

        {fa.note && (
          <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, padding: '12px 14px', marginTop: SPACE.md }}>
            <div style={{ fontSize: TYPO.sizes.base, color: COLORS.muted, marginBottom: 6, fontWeight: TYPO.weights.bold, letterSpacing: '0.05em' }}>POZNÁMKA</div>
            <div style={{ fontSize: TYPO.sizes.sm, whiteSpace: 'pre-wrap' }}>{fa.note}</div>
          </div>
        )}

        {fa.source === 'mksoft' && (
          <div style={{ padding: SPACE.sm, background: COLORS.navBg, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.xs, color: COLORS.nav, marginTop: SPACE.md }}>
            Táto faktúra je naimportovaná z MKsoft (system of record pre účtovníctvo).
            Pre úpravu / zrušenie / dobropis použi MKsoft priamo.
          </div>
        )}
      </div>
    </div>
  )
}

// Field — KROS štýl pole (label hore + hodnota v rámčeku), read-only
function Field({ label, value, mono }) {
  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 4 }}>{label}</div>
      <div style={{ padding: '8px 10px', background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, fontFamily: mono ? TYPO.mono : 'inherit', whiteSpace: 'normal', wordBreak: 'break-word', color: COLORS.text }}>{(value !== null && value !== undefined && value !== '') ? value : '—'}</div>
    </div>
  )
}

function SumCard({ label, value, color, highlight }) {
  return (
    <div style={{
      background: highlight ? COLORS.bgSoft : COLORS.bg,
      border: `1px solid ${COLORS.line}`,
      borderLeft: `4px solid ${color}`,
      borderRadius: RADIUS.md,
      padding: SPACE.md
    }}>
      <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color, marginBottom: 4 }}>
        {label}
      </div>
      <div style={{ fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.bold, fontFamily: TYPO.mono, color: COLORS.text }}>
        {value}
      </div>
    </div>
  )
}

// Parser eKasa poznámky (fallback ak items=0)
function parseNotesEkasa(notes) {
  if (!notes) return { ekasaCode: '', items: [] }
  const lines = notes.split('\n')
  const codeMatch = lines[0] && lines[0].match(/(?:eKasa:?\s*)?(O-[0-9A-F]+)/i)
  const ekasaCode = codeMatch ? codeMatch[1] : ''
  const rest = codeMatch ? lines.slice(1).join(', ') : notes
  if (!rest) return { ekasaCode, items: [] }
  // Položky oddelené čiarkami s cenou: "Capucino 7€, Latte 2.5€"
  const items = []
  const tokens = rest.split(/[,\n]/).map(t => t.trim()).filter(Boolean)
  for (const tok of tokens) {
    const m = tok.match(/^(.+?)\s+([\d]+(?:[.,]\d+)?)\s*€?\s*$/)
    if (m) {
      items.push({
        name: m[1].trim(),
        qty: 1, unit: 'ks',
        price_unit: parseFloat(m[2].replace(',', '.')),
        price_total: parseFloat(m[2].replace(',', '.')),
        vat_rate: 0,
      })
    }
  }
  return { ekasaCode, items }
}

// VAT_FROM_ITEMS_v2 — Rozpis DPH per sadzba
// Priorita: 1) items (group by vat_rate), 2) fa.vat_lines JSON, 3) fallback z totalu
function computeVatLines(fa, items) {
  if (!fa) return []
  // FVSVP = prenos DPH §69 VŽDY (ústava 17) — aj pri nekonzistentných dátach v hlavičke
  // (Mirko 2026-07-06: FA 1260069 mala excl 3827 vs total 9417 → padala na fiktívne 20 %)
  if (fa.typ === 'FVSVP' || fa.typ === 'FVSP') return [{ rate: 0, base: Number(fa.amount_total || 0), amount: 0, pdp: true }]
  // PRENESENIE DAŇOVEJ POVINNOSTI (stavebné práce §69/12): hlavička hovorí DPH 0 a základ == total → NEdopočítavaj fiktívnu DPH (Mirko 2026-06-29).
  {
    const _t = Number(fa.amount_total || 0)
    const _v = Number(fa.amount_vat || 0)
    const _b = Number(fa.amount_excl_vat ?? fa.amount_ex_vat ?? 0)
    if (_t > 0 && Math.abs(_v) < 0.005 && _b > 0 && Math.abs(_b - _t) < 0.02) {
      return [{ rate: 0, base: _t, amount: 0, pdp: true }]
    }
  }
  // 1) Zo zoznamu položiek — group by vat_rate (najpresnejšie pre multi-rate bloček)
  if (Array.isArray(items) && items.length > 0) {
    // p37 (17. 9. 2026): bloček má položky s DPH, došlá faktúra spravidla bez DPH — rozhodnú sumy dokladu (utils/dokladPolozky.js)
    const sDph = polozkySDph(fa, items, fa.source !== 'incoming')
    const buckets = {}
    items.forEach(it => {
      const total = Number(it.price_total || it.amount_total || it.amount || it.suma || it.total || 0)
      const rate = Number(it.vat_rate || 0)
      if (total <= 0) return
      const base = sDph && rate > 0 ? +(total / (1 + rate / 100)).toFixed(2) : +total.toFixed(2)
      const amount = sDph ? +(total - base).toFixed(2) : 0   // položky bez DPH: DPH sa počíta zo súčtu sadzby, ako na faktúre
      const key = String(rate)
      if (!buckets[key]) buckets[key] = { rate, base: 0, amount: 0 }
      buckets[key].base += base
      buckets[key].amount += amount
    })
    const arr = Object.values(buckets)
      .map(b => ({ rate: b.rate, base: +b.base.toFixed(2), amount: sDph ? +b.amount.toFixed(2) : +(b.base * b.rate / 100).toFixed(2) }))
      .filter(b => b.base > 0 || b.amount > 0)
      .sort((a, b) => a.rate - b.rate)
    if (arr.length > 0) return arr
  }
  // 2) DB vat_lines JSON
  try {
    const v = typeof fa.vat_lines === 'string' ? JSON.parse(fa.vat_lines || '[]') : fa.vat_lines
    const arr = Array.isArray(v) ? v.filter(x => (x.base || 0) > 0 || (x.amount || 0) > 0) : []
    if (arr.length > 0) return arr
  } catch (_) {}
  // 3) Fallback z totalu + sadzby
  const total = parseFloat(fa.amount_total ?? 0)
  const rate = parseFloat(fa.vat_rate ?? 0)
  if (total <= 0) return []
  let base = parseFloat(fa.amount_excl_vat ?? fa.amount_ex_vat ?? 0)
  if (base <= 0 && rate > 0) base = parseFloat((total / (1 + rate / 100)).toFixed(2))
  if (base <= 0) base = total
  const vatAmt = parseFloat((total - base).toFixed(2))
  return [{ rate, base, amount: vatAmt }]
}

// p45 (Mirko 17. 9. 2026: „doklad má položky“): keď doklad položky nemá, prečítajú sa z priloženého PDF alebo fotky
function NacitatPolozky({ fa, onReload, maly }) {
  const toast = useToast()
  const [busy, setBusy] = useState(false)
  if (fa.source !== 'incoming' || !fa.doc_file) return null
  const nacitaj = async () => {
    setBusy(true)
    try {
      const r = await fetchAuth(`/api/incoming-invoices/${fa.realId}/polozky-z-dokladu`, { method: 'POST' })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) { toast.error(d.error || 'Čítanie zlyhalo'); return }
      toast.success('Načítané z dokladu: ' + d.polozky + ' ' + (d.polozky === 1 ? 'položka' : d.polozky < 5 ? 'položky' : 'položiek'))
      onReload && onReload()
    } catch (e) { toast.error('Chyba: ' + e.message) } finally { setBusy(false) }
  }
  return <BtnGhost size={maly ? 'sm' : undefined} onClick={nacitaj} disabled={busy} title="Matrix prečíta položky z priloženého dokladu">{busy ? 'Čítam doklad…' : 'Načítať položky z dokladu'}</BtnGhost>
}

function PolozkyTab({ items, loading, fa }) {
  if (loading) return <div style={{ color: COLORS.muted, padding: SPACE.md }}>Načítavam položky…</div>

  const isIncoming = fa.source === 'incoming'
  const parsed = isIncoming ? parseNotesEkasa(fa.note || fa.notes || '') : { ekasaCode: '', items: [] }
  const displayItems = items && items.length > 0 ? items : parsed.items
  const vatLines = computeVatLines(fa, displayItems)
  const totalVat = vatLines.reduce((s, v) => s + (v.amount || 0), 0)
  const polozkySoDph = polozkySDph(fa, displayItems, !isIncoming)   // p37: ceny položiek s DPH (bloček) alebo bez DPH (faktúra)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      {/* ROZPIS DPH (ústava 12 — bloček + DPH per sadzba) */}
      {vatLines.length > 0 && (
        <div style={{
          padding: SPACE.md, background: COLORS.bgSoft,
          border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
        }}>
          <div style={{
            fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
            color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.06em',
            marginBottom: SPACE.sm,
          }}>Rozpis DPH</div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
            <thead>
              <tr style={{ color: COLORS.muted, fontSize: TYPO.sizes.xs }}>
                <th style={{ textAlign: 'left',  padding: '3px 8px 6px 0' }}>Sadzba</th>
                <th style={{ textAlign: 'right', padding: '3px 8px 6px' }}>Základ</th>
                <th style={{ textAlign: 'right', padding: '3px 8px 6px' }}>DPH</th>
                <th style={{ textAlign: 'right', padding: '3px 0 6px 4px' }}>Spolu</th>
              </tr>
            </thead>
            <tbody>
              {vatLines.map((v, i) => (
                <tr key={i} style={{ borderTop: `1px solid ${COLORS.lineSoft}` }}>
                  <td style={{ padding: '6px 8px 6px 0', fontWeight: TYPO.weights.bold, color: COLORS.nav }}>{v.pdp ? 'Prenesenie DP' : v.rate + '%'}</td>
                  <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: TYPO.mono }}>{SK.eur(v.base)}</td>
                  <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: TYPO.mono, color: COLORS.total }}>{v.pdp ? '—' : '+' + SK.eur(v.amount)}</td>
                  <td style={{ padding: '6px 0 6px 4px', textAlign: 'right', fontFamily: TYPO.mono, fontWeight: TYPO.weights.semibold }}>{SK.eur((v.base || 0) + (v.amount || 0))}</td>
                </tr>
              ))}
              {vatLines.length > 1 && (
                <tr style={{ borderTop: `2px solid ${COLORS.line}` }}>
                  <td colSpan={2} style={{ padding: '6px 8px 0 0', color: COLORS.muted, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold }}>CELKOM DPH / SUMA</td>
                  <td style={{ padding: '6px 8px 0', textAlign: 'right', fontFamily: TYPO.mono, color: COLORS.total, fontWeight: TYPO.weights.bold }}>+{SK.eur(totalVat)}</td>
                  <td style={{ padding: '6px 0 0 4px', textAlign: 'right', fontFamily: TYPO.mono, fontWeight: TYPO.weights.extra, fontSize: TYPO.sizes.md }}>{SK.eur(fa.amount_total)}</td>
                </tr>
              )}
            </tbody>
          </table>
          {vatLines.some(v => v.pdp) && <div style={{ marginTop: 6, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Prenesenie daňovej povinnosti — §69 ods. 12 zákona o DPH (stavebné práce). Daň odvádza odberateľ.</div>}
        </div>
      )}

      {/* POLOŽKY */}
      {displayItems.length === 0 ? (
        <div style={{ padding: SPACE.lg, color: COLORS.muted, textAlign: 'center', background: COLORS.bgSoft, borderRadius: RADIUS.md }}>
          <div style={{ fontSize: 32, marginBottom: SPACE.xs }}></div>
          <div>Pre {isIncoming && (fa.docType === 'blocok' || fa.typ === 'BLOCEK') ? 'tento bloček' : 'túto faktúru'} nie sú evidované jednotlivé položky.</div>
          {isIncoming && parsed.ekasaCode && (
            <div style={{ fontSize: TYPO.sizes.xs, marginTop: SPACE.xs, fontFamily: TYPO.mono, color: COLORS.muted }}>
              eKasa kód: {parsed.ekasaCode}
            </div>
          )}
        </div>
      ) : (
        <div style={{
          padding: SPACE.md, background: COLORS.bgSoft,
          border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            marginBottom: SPACE.sm,
          }}>
            <div style={{
              fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold,
              color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '0.06em',
            }}>Položky ({displayItems.length}){items.length === 0 && parsed.items.length > 0 ? ' — z poznámky' : ''}{displayItems.length > 0 ? (polozkySoDph ? ' · ceny s DPH' : ' · ceny bez DPH') : ''}</div>
            {parsed.ekasaCode && (
              <span style={{ fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{parsed.ekasaCode}</span>
            )}
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
            <thead>
              <tr style={{ borderBottom: `1px solid ${COLORS.line}` }}>
                <th style={{ textAlign: 'left', padding: '4px 6px 6px 0', color: COLORS.muted, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Popis</th>
                <th style={{ textAlign: 'right', padding: '4px 6px 6px', color: COLORS.muted, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>Mn.</th>
                <th style={{ textAlign: 'right', padding: '4px 6px 6px', color: COLORS.muted, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>JC</th>
                <th style={{ textAlign: 'right', padding: '4px 6px 6px', color: COLORS.muted, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>DPH</th>
                <th style={{ textAlign: 'right', padding: '4px 0 6px 4px', color: COLORS.muted, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>Spolu</th>
              </tr>
            </thead>
            <tbody>
              {/* FAKT_ITEMS_ZEBRA — striedanie pre prehľadnosť */}
              {displayItems.map((it, i) => {
                const isPdp = fa && (fa.typ === 'FVSVP' || fa.typ === 'FVSP')  // prenos §69 — položky bez DPH (ústava 17)
                const total = isPdp
                  ? Number(it.amount_excl_vat || 0) || (Number(it.price_total || it.amount_total || 0) / (1 + (Number(it.vat_rate) || 0) / 100))
                  : Number(it.price_total || it.amount_total || it.amount || it.suma || it.total || 0)
                const vatR = isPdp ? 0 : Number(it.vat_rate || 0)
                const base = vatR > 0 && polozkySoDph ? +(total / (1 + vatR / 100)).toFixed(2) : total
                const dph = polozkySoDph ? +(total - base).toFixed(2) : +(total * vatR / 100).toFixed(2)
                const qty = Number(it.qty || it.quantity || it.mnozstvo || 1)
                const unit = it.unit || it.mj || 'ks'
                const priceUnit = Number(it.price_unit || it.unit_price || it.jc || it.cena || 0)
                return (
                  <tr key={it.id || i} style={{ borderBottom: `1px solid ${COLORS.lineSoft}`, background: i % 2 ? COLORS.bg : 'transparent' }}>
                    <td style={{ padding: '6px 6px 6px 0' }}>{it.name || it.description || it.popis || '—'}</td>
                    <td style={{ padding: '6px 6px', textAlign: 'right', fontFamily: TYPO.mono, color: COLORS.muted, fontSize: TYPO.sizes.xs, whiteSpace: 'nowrap' }}>
                      {qty !== 1 ? `${qty} ${unit}` : unit}
                    </td>
                    <td style={{ padding: '6px 6px', textAlign: 'right', fontFamily: TYPO.mono, color: COLORS.muted, fontSize: TYPO.sizes.xs, whiteSpace: 'nowrap' }}>
                      {priceUnit > 0 ? SK.eur(priceUnit) : '—'}
                    </td>
                    <td style={{ padding: '6px 6px', textAlign: 'right', fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, whiteSpace: 'nowrap' }}>
                      {vatR > 0
                        ? <span style={{ color: COLORS.total }}>{vatR}% <span style={{ fontSize: 10, color: COLORS.muted }}>+{SK.eur(dph)}</span></span>
                        : <span style={{ color: COLORS.muted }}>{(fa && (fa.typ === 'FVSVP' || fa.typ === 'FVSP')) ? 'PDP §69' : '0%'}</span>}
                    </td>
                    <td style={{ padding: '6px 0 6px 4px', textAlign: 'right', fontFamily: TYPO.mono, fontWeight: TYPO.weights.semibold }}>{SK.eur(total)}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

function AuditTab({ fa }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      <div>
        <h3 style={{ margin: 0, marginBottom: SPACE.sm, fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.bold }}>História záznamu</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
          <tbody>
            <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <td style={{ padding: '6px 8px', color: COLORS.muted, width: 180 }}>ID v Matrix</td>
              <td style={{ padding: '6px 8px', fontFamily: TYPO.mono }}>{fa.id}</td>
            </tr>
            <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <td style={{ padding: '6px 8px', color: COLORS.muted }}>Zdroj</td>
              <td style={{ padding: '6px 8px' }}>
                {fa.source === 'mksoft' ? 'Synchronizované z MKsoft' : 'Vytvorené priamo v Matrix'}
              </td>
            </tr>
            <tr style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <td style={{ padding: '6px 8px', color: COLORS.muted }}>Stav</td>
              <td style={{ padding: '6px 8px' }}>{fa.status || '—'}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {fa.source === 'mksoft' && (
        <div style={{ padding: SPACE.md, background: COLORS.bgSoft, borderRadius: RADIUS.md }}>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 4 }}>MKsoft synchronizácia</div>
          <div style={{ fontSize: TYPO.sizes.sm }}>
            MKsoft číslo: <b style={{ fontFamily: TYPO.mono }}>{fa.cislo}</b>
          </div>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2 }}>
            MKsoft = system of record pre účtovníctvo. Matrix čítá read-only mirror.
          </div>
        </div>
      )}

      <div style={{ padding: SPACE.md, background: 'rgba(245,158,11,0.10)', border: `1px solid ${COLORS.total}`, borderRadius: RADIUS.md, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
        <b>Pripravujeme</b>: úhrady z bankového výpisu (VÚB/George) automatické párovanie podľa VS — sek. 11, sek. 17. Zatiaľ MKsoft sync prináša stav, ručná úprava nie je v Matrix v2 dostupná.
      </div>
    </div>
  )
}
